import ConfirmModalCheckboxNote from './ConfirmModalCheckboxNote';

export const RELEASE_DETECTION_STRATEGIES = {
  TAG: 'tag',
  RELEASE_BRANCHES: 'release_branch',
  MERGE_COMMITS: 'merge_commits',
  REPORTED: 'reported',
  DEPLOYMENT: 'deployment'
};

const defaultOptionsModalSize = {
  modalHeight: '30rem',
  modalWidth: '42rem'
};

const defaultOptions = {
  checkbox: {
    key: 'backfill_days_backward',
    label: 'backfill my releases for the last 90 days',
    checked_value: 90,
    unchecked_value: 1,
    is_checked_by_default: true,
    CheckboxCheckedNote: <ConfirmModalCheckboxNote />
  },
  ...defaultOptionsModalSize
};

export const CUSTOM_OPTIONS = {
  lighthouse: {
    code: 'vnw2fw6226',
    description: 'Learn more >'
  },
  [RELEASE_DETECTION_STRATEGIES.TAG]: {
    confirmation_modal: {
      ...defaultOptions,
      confirmation_text: 'Detect my releases using tags'
    }
  },
  [RELEASE_DETECTION_STRATEGIES.RELEASE_BRANCHES]: {
    confirmation_modal: {
      ...defaultOptions,
      confirmation_text:
        'Detect my releases by Pull Requests to a dedicated branch'
    }
  },
  [RELEASE_DETECTION_STRATEGIES.MERGE_COMMITS]: {
    confirmation_modal: {
      ...defaultOptions,
      confirmation_text:
        'Detect my releases by direct merges to a dedicated branch (using --no-ff merges)'
    }
  },
  [RELEASE_DETECTION_STRATEGIES.REPORTED]: {
    confirmation_modal: {
      confirmation_text: 'Detect my release using API',
      ...defaultOptionsModalSize
    }
  }
};

export const RELEASE_DETECTION_OPTIONS = [
  {
    hint: '.*',
    input: 'isArray',
    label: 'Detect my releases using tags',
    subtext:
      'Please specify a regular expression to help identifying your release tags or leave the default value to consider all tags as release related.',
    radio_value: RELEASE_DETECTION_STRATEGIES.TAG
  },
  {
    hint: '^(master|main|prod|production)$',
    input: 'isArray',
    label: 'Detect my releases by Pull Requests to a dedicated branch',
    subtext:
      'Please specify a regular expression to help identifying the dedicated branch.',
    radio_value: RELEASE_DETECTION_STRATEGIES.RELEASE_BRANCHES
  },
  {
    hint: '^(master|main|prod|production)$',
    input: 'isArray',
    label:
      'Detect my releases by direct merges to a dedicated branch (using --no-ff merges)',
    subtext:
      'Please specify a regular expression to help identifying the dedicated branch.',
    radio_value: RELEASE_DETECTION_STRATEGIES.MERGE_COMMITS
  },
  {
    adminOnly: true,
    label: 'API Integration',
    blockedMessage:
      'Please contact your admin to be able to select this option',
    subtext:
      'Releases and custom cycle time stages reported via API integration',
    radio_value: RELEASE_DETECTION_STRATEGIES.REPORTED,
    withApiToken: true
  }
];
